/*
 * Birthday Offer — assets/birthday-offer.js
 *
 * No network call: the form is a native Shopify customer form and posts
 * itself. This script only validates, and turns the date of birth into the
 * tags Shopify will actually persist — a customer form drops any field it
 * does not recognise, so the date cannot travel as its own input.
 *
 * Tags written:
 *   birthday-club     the whole list, as one segmentable tag
 *   bday-YYYY-MM-DD   the full date
 *   bday-month-MM     the month alone, which is what Shopify's segment query
 *                     language can filter on (it cannot extract a month from
 *                     a date value)
 */
(function () {
  /* ── Calendar ─────────────────────────────────────────────────────────────
   * Liquid draws this from the shop's clock. That is correct for the shop and
   * wrong for everyone else: a reader whose date has already rolled over sees
   * yesterday circled, and a cached page can be staler still. Redraw from the
   * visitor's own date, which is what a "today" marker should mean.
   * ──────────────────────────────────────────────────────────────────────── */
  function drawCalendar(root) {
    var monthEl = root.querySelector('[data-cal-month]');
    var grid = root.querySelector('[data-cal-grid]');
    if (!monthEl || !grid) return;

    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    var today = now.getDate();
    var lang = document.documentElement.lang || 'en';

    var firstWeekday = new Date(year, month, 1).getDay();
    /* Day 0 of next month is the last day of this one — avoids a leap rule. */
    var daysInMonth = new Date(year, month + 1, 0).getDate();
    var todayRow = Math.floor((firstWeekday + today - 1) / 7);

    monthEl.textContent = now.toLocaleDateString(lang, { month: 'long' }).toUpperCase();

    var cells = '';
    for (var i = 0; i < 42; i++) {
      var day = i - firstWeekday + 1;
      if (day < 1 || day > daysInMonth) {
        cells += '<span class="birthday-cal__day birthday-cal__day--empty"></span>';
        continue;
      }
      var cls = 'birthday-cal__day';
      if (Math.floor(i / 7) === todayRow) cls += ' is-week';
      if (day === today) cls += ' is-today';
      cells += '<span class="' + cls + '">' + day + '</span>';
    }
    grid.innerHTML = cells;

    var aria = root.getAttribute('data-cal-aria');
    if (aria) root.setAttribute('aria-label', aria.replace('[month]', monthEl.textContent));
  }

  document.querySelectorAll('[data-cal]').forEach(drawCalendar);

  function iso(date) {
    return date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0');
  }

  document.querySelectorAll('[data-birthday-form]').forEach(function (wrap) {
    var form = wrap.querySelector('form');
    if (!form) return;

    var dobEl = wrap.querySelector('[data-birthday-dob]');
    var tagsEl = wrap.querySelector('[data-birthday-tags]');
    var errorEl = wrap.querySelector('[data-birthday-error]');
    var d = wrap.dataset;
    var field = function (name) { return form.elements[name]; };

    /* No max: the field accepts any date. Parents reach for the upcoming
       birthday as readily as the birth date, and only the day and month are
       used to time anything, so both readings work. */

    /* Read the date back in words, and say when the code lands. Runs on every
       change so the answer tracks what is actually in the field. */
    var readback = wrap.querySelector('[data-birthday-readback]');

    function nextBirthday(value) {
      var parts = value.split('-');
      if (parts.length !== 3) return null;
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var next = new Date(today.getFullYear(), Number(parts[1]) - 1, Number(parts[2]));
      if (next < today) next.setFullYear(next.getFullYear() + 1);
      return next;
    }

    function monthLabel(date) {
    return date.toLocaleDateString(document.documentElement.lang || 'en', {
      month: 'long'
    });
  }

  function label(date) {
      return date.toLocaleDateString(document.documentElement.lang || 'en', {
        day: 'numeric', month: 'long'
      });
    }

    function updateReadback() {
      if (!readback || !dobEl) return;
      var next = dobEl.value.trim() ? nextBirthday(dobEl.value.trim()) : null;
      if (!next) { readback.hidden = true; return; }

      var today = new Date();
      today.setHours(0, 0, 0, 0);
      /* One campaign goes out at the start of each birthday month, so the
         only two honest answers are "at the start of <month>" and, once that
         month has begun, "on its way". */
      var thisMonth = next.getFullYear() === today.getFullYear()
        && next.getMonth() === today.getMonth();

      readback.textContent = thisMonth
        ? (d.msgSoon || '').replace('[date]', label(next))
        : (d.msgArrives || '').replace('[date]', monthLabel(next));
      readback.hidden = false;
    }

    if (dobEl) {
      dobEl.addEventListener('change', updateReadback);
      dobEl.addEventListener('input', updateReadback);
      updateReadback();
    }

    function fail(event, message, el) {
      event.preventDefault();
      if (errorEl) { errorEl.textContent = message; errorEl.hidden = false; }
      if (el) el.focus();
    }

    form.addEventListener('submit', function (event) {
      if (errorEl) errorEl.hidden = true;

      var honeypot = field('contact[company]');
      if (honeypot && honeypot.value) { event.preventDefault(); return; }

      var name = field('contact[first_name]');
      var email = field('contact[email]');
      var consent = field('contact[accepts_marketing]');
      var dob = dobEl ? dobEl.value.trim() : '';

      if (!name || !name.value.trim()) return fail(event, d.msgRequired, name);
      if (!email || email.value.indexOf('@') < 1) return fail(event, d.msgEmail, email);
      if (!dob) return fail(event, d.msgDob, dobEl);
      if (consent && !consent.checked) return fail(event, d.msgConsent, consent);

      /* Shopify splits this on commas. Written at submit time so the value is
         always the date actually in the field. */
      if (tagsEl) {
        tagsEl.value = ['birthday-club', 'bday-' + dob, 'bday-month-' + dob.slice(5, 7)].join(',');
      }
      /* No preventDefault from here: the browser posts the form to Shopify. */
    });
  });
})();
